import '@fancyapps/fancybox'

jQuery(document).ready(function( $ ) {

    $().fancybox({
        caption : function( instance, item ) {
            var caption = $(this).data('caption') || ''
            return caption
        }
    })

    $.fancybox.defaults.buttons = ["zoom", "share", "slideShow", "fullScreen", "close"]
    $.fancybox.defaults.slideShow = {speed: 6000}
    $.fancybox.defaults.transitionEffect = "slide"
    $.fancybox.defaults.transitionDuration = 600
    $.fancybox.defaults.animationDuration = 600
    $.fancybox.defaults.loop = true
    $.fancybox.defaults.mobile.idleTime = false
    $.fancybox.defaults.mobile.clickSlide = "close"
    $.fancybox.defaults.lang = "fr"
    $.fancybox.defaults.i18n = {
        fr: {
            CLOSE: "Fermer",
            NEXT: "Suivant",
            PREV: "Précédent",
            ERROR: "Le contenu demandé ne peut pas être chargé. <br/> Merci de réessayer ultérieurement.",
            PLAY_START: "Démarrer le diaporama",
            PLAY_STOP: "Mettre le diaporama en pause",
            FULL_SCREEN: "Plein écran",
            THUMBS: "Miniatures",
            DOWNLOAD: "Télécharger",
            SHARE: "Partager",
            ZOOM: "Zoom"
        },
        en: {
            CLOSE: "Close",
            NEXT: "Next",
            PREV: "Previous",
            ERROR: "The requested content cannot be loaded. <br/> Please try again later.",
            PLAY_START: "Start slideshow",
            PLAY_STOP: "Pause slideshow",
            FULL_SCREEN: "Full screen",
            THUMBS: "Thumbnails",
            DOWNLOAD: "Download",
            SHARE: "Share",
            ZOOM: "Zoom"
        }
    }
})
